import { useState, useEffect, useContext, useRef } from 'react';
import PageContext from '../sub-components/PageContext';
import HeaderBanner from '../sub-components/HeaderBanner.tsx';
import Footer from "../sub-components/Footer.tsx";
import OrderedDataTable from '../sub-components/OrderedDataTableCopy.jsx';
import RebateSummaryEditRowModal from '../sub-components/RebateSummaryEditRowModal';
import RebateCommentModal from '../sub-components/RebateCommentModal.jsx';
import RebateTrailModal from '../sub-components/RebateTrailModal.jsx';
import RebateSummaryRow from '../sub-components/RebateSummaryRow';
import ExportExcelButton from '../sub-components/ExportExcelButton'; 
import standardSearch from '../functions/standardSearch';
import standardFilter from '../functions/standardFilter';
import applyFilters from '../functions/applyFilters';
import MultipartWorkflowButton from '../sub-components/MultipartWorkflowButton';
import MultipartOffcanvas from '../sub-components/MultipartOffcanvas';
import { HttpContext } from '../../api-services/HttpService';
import eligibleFilter from '../functions/eligibleFilter'; 
import SnackbarAlert from '../sub-components/SnackbarAlert'; 
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from 'redux';
import { actionCreators } from "../../redux/index";
import PageDropdownRedux from '../sub-components/PageDropdownReduxCopy.jsx';
import PageInputReduxTooltip from '../sub-components/PageInputReduxTooltopCopy.jsx'; 
import PageBreadcrumbs from '../sub-components/PageBreadcrumbs.jsx';  
import { Typography } from '@mui/material';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import PageDropdownReduxWithIdObj from '../sub-components/PageDropdownReduxWithIdObj.jsx';
import workflowIndicatorFilter from '../functions/workflowIndicatorFilter.js';
import RebatePayoutEditModal from '../sub-components/RebatePayoutEditModal.jsx';
import ButtonComponent from '../sub-components/ButtonComponent';

// role id allowed to edit pay period
const PAY_PERIOD_EDITOR_ROLE_ID = '2';

// import temp data to display 
const workflowActionInfo = require('../../TempValueFiles/workflowActionData');

const RebateSummaryPage = () =>{
    // initialize http context 
    const {
        GET, 
    } = useContext(HttpContext);
    // initialize redux persistant state
    const rebateSummarySearch = useSelector((state) => state.rebateSummarySearch);
    const rebateSummaryPeriod = useSelector((state) => state.rebateSummaryPeriod); 
    const rebateFrequency = useSelector((state) => state.rebateFrequency);
    const workflowEligible = useSelector((state) => state.workflowEligible); 
    const workflowStatus = useSelector((state) => state.workflowStatus); 
    const rebatePortfolio2 = useSelector((state) => state.rebatePortfolio2); 
    const workflowType = useSelector((state) => state.workflowType);
    const workflowIndicator = useSelector((state) => state.workflowIndicator); 
    const companyTypeFilter2 = useSelector((state) => state.companyTypeFilter2); 
    const dispatch = useDispatch();
    const { 
        setRebateSummarySearch, 
        setRebateSummaryPeriod, 
        setRebateFrequency, 
        setWorkflowEligible,
        setWorkflowStatus,
        setRebatePortfolio2, 
        setWorkflowType, 
        setWorkflowIndicator, 
        setCompanyTypeFilter2
    } = bindActionCreators(actionCreators, dispatch);
    // search dropdown states
    const [periodList, setPeriodList] = useState([]);
    const [periodId, setPeriodId] = useState('');
    const [frequencyList, setFrequencyList] = useState([]);
    const [workflowEligibleList, setWorkFlowEligibleList] = useState([]);
    const [rebatePortfolioList, setRebatePortfolioList] = useState([]);
    const [workflowTypeList, setWorkflowTypeList] = useState([]); 
    const [workflowIndicatorList, setWorkflowIndicatorList] = useState([]); 
    const [companyTypeFilterList, setCompanyTypeFilterList] = useState(['All']); 
    const [allObj, setAllObj] = useState({id: 'All', label: 'All' }); 
    // state for table 
    const [showDataList, setShowDataList] = useState([]); // show data list for displaying filtered list in table
    const [dataList, setDataList] = useState([]); // data list to have complete list if filters are reset/changed
    const [tableHeader, setTableHeader] = useState([]);
    // set editRow modal variables
    const [editRowModal, setEditRowModal] = useState(false);
    const [commentModal, setCommentModal] = useState(false);
    const [trailModal, setTrailModal] = useState(false);
    const [pencilModal, setPencilModal] = useState(false);
    // rows targeted by the pay period modal (single row from pencil icon, many from bulk action)
    const [payPeriodRows, setPayPeriodRows] = useState([]);
    // holidays from Lookup_Holiday, used to warn when a pay period date is a holiday
    const [holidays, setHolidays] = useState([]);
    // pay period selection mode: independent of workflow status, any row the user can edit pay period for is selectable
    const [payPeriodMode, setPayPeriodMode] = useState(false);
    const canEditPayPeriod = (row) => row['userroleid'] == PAY_PERIOD_EDITOR_ROLE_ID;
    const [editRow, setEditRow] = useState({});
    // state to make check box change in sub component
    const [checkBoxChange, setCheckBoxChange] = useState(false);
    // useRef to determine if initialRender
    const initialRender = useRef(true);
    // initialize state for workflow actions
    const [userRole, setUserRole] = useState('0');
    const [userRoleList, setUserRoleList] = useState([]);    
    const workflowActionData = useRef([]);
    //workflow action
    const [workflowAction, setWorkflowAction] = useState('');
    const [workflowActionList, setWorkflowActionList] = useState([]);
    //workflow status
    const [workflowActionStatus, setWorkflowActionStatus] = useState('');
    const [workflowActionStatusList, setWorkflowActionStatusList] = useState([]);
    const [workflowActionCheckedList, setWorkflowActionCheckedList] = useState([]);
    // initialize multipart workflow modal state
    const [multipartWorkflowModal, setMultipartWorkflowModal] = useState(false);
    const [multipartWorkflowAction, setMultipartWorkflowAction] = useState('');
    // initialize reference for workflow modal
    const workflowButtonCss = useRef('modal-button-full-blue');
    const workflowOptOut = useRef(false);
    const workflowReviewAction = useRef(false);
    // check all boxes state var and list to hold checked rows var
    const [checkAll, setCheckAll] = useState(false);
    // initialize spinner state
    const [showSpinner, setShowSpinner] = useState(false);
    // initalize state to filter out non-eligible workflows from table 
    const [eligiblePeriod, setEligiblePeriod] = useState(null);
    // initialize state for snackbar
    const [showSnackbar, setShowSnackbar] = useState(false); 
    const [snackbarMessage, setSnackbarMessage] = useState(''); 
    const [snackbarColor, setSnackbarColor] = useState('warning'); 
    const [enableReset, setEnableReset] = useState(false);
    const [isMenuLoaded, setIsMenuLoaded] = useState(false);

    // set state for excel export format list 
    const [fmtList, setFmtList] = useState([
        {col: 'I', columnname: 'minimumspend', float: true, fmt: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)'}, // money format
        {col: 'K', columnname: 'grossspend', float: true, fmt: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)'}, // money format
        {col: 'J', columnname: 'incentiveamount', float: true, fmt: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)'}, // money format
    ]); 

    // function to set snackbar state
    const snackbarAlert = (show, message, color) => {
        setShowSnackbar(showSnackbar => showSnackbar = show); 
        setSnackbarMessage(snackbarMessage => snackbarMessage = message); 
        setSnackbarColor(snackbarColor => snackbarColor = color); 
    } 

    //reset functionality 
    const resetToDefault = () => {
        setRebateSummaryPeriod(periodList[0]);
        setWorkflowEligible(workflowEligibleList[0]);
        setRebateFrequency(frequencyList[0]);
        setWorkflowStatus(workflowActionStatusList[0]);
        setWorkflowType(workflowTypeList[0]); 
        setRebatePortfolio2(rebatePortfolioList[0]); 
        setCompanyTypeFilter2(companyTypeFilterList[0]); 
        setRebateSummarySearch('');
    }

    const enableResetAll = () => {
        if(rebateSummaryPeriod !== periodList[0] || workflowEligible !== workflowEligibleList[0]
            || rebateFrequency !== frequencyList[0] || workflowStatus !== workflowActionStatusList[0]
                || rebateSummarySearch !== '' || workflowType !== workflowTypeList[0] || rebatePortfolio2 !== rebatePortfolioList[0]
                || companyTypeFilter2 !== companyTypeFilterList[0] 
        ){
            return true;
        }
        return false;
    }

    useEffect(() => {
        if(isMenuLoaded && enableResetAll()){
            setEnableReset(true);
        } else {
            setEnableReset(false);
        }
    }, [rebateSummaryPeriod, workflowEligible, rebateFrequency, workflowStatus, rebateSummarySearch, workflowType, rebatePortfolio2, companyTypeFilter2, isMenuLoaded])

    //get lookups for rebate summary page
    const getSummaryLookups = () => {
        return new Promise((resolve, reject) => {
            GET('rebate/summary/lookups').then(res => {
                console.log(res); 
                // set frequency states
                setFrequencyList(frequencyList => frequencyList = ['All', ...res.data.FreqDescriptionsLookup.map(freq => freq.frequencydescription)]);
                setWorkFlowEligibleList(workflowEligibleList => workflowEligibleList = ['All', 'Eligible', 'Non-Eligible'])
                // set period states
                setPeriodList(periodList => periodList = [...res.data.PeriodIdsLookup.map(period => period.periodid)]);
                // if there is no periodid in redux persistant state set periodid 
                if (rebateSummaryPeriod == '' ){
                    setRebateSummaryPeriod(res.data.PeriodIdsLookup[0].periodid); 
                }
                //set workflow action status
                setWorkflowActionStatusList(workflowActionStatusList => workflowActionStatusList =['All', ...res.data.WorkflowStatusLookup.map(status => status.workflowstatusdescription)]);
                setWorkflowActionStatus(workflowActionStatus => workflowActionStatus = workflowStatus);
                setUserRoleList(userRoleList => userRoleList = ['0', ...res.data.WorkflowStatusLookup.map(status => status.userroleid)]);
                // set state for filters 
                setRebatePortfolioList(rebatePortfolioList => rebatePortfolioList = ['All', ...res['data']['RebatePortfolioLookup']]); 
                setWorkflowTypeList(workflowTypeList => workflowTypeList = ['All', ...res['data']['WorkflowTypeLookup']]); 
                setCompanyTypeFilterList(companyTypeFilterList => companyTypeFilterList = ['All', ...res['data']['CompanyTypeLookup']]); 
                // set state of indicator filters 
                setWorkflowIndicatorList(workflowIndicatorList => workflowIndicatorList = [allObj, ...res['data']['WorkflowIndicatorLookup']]); 
                // set loading state
                setIsMenuLoaded(true);
                // resolve on success
                resolve(res);
           }).catch(err => {
                reject(err);
                setIsMenuLoaded(false);
           }) 
        });
    }

    // create function for getting/reading resbate summary data from DB for a specfic users entitlements, function takes in 1 userid and returns a promise
    const getSummaryData = async (periodId) => {
        setShowSpinner(showSpinner => showSpinner = true);
        return new Promise((resolve, reject) => {
            GET('/rebate/summary', { periodId: periodId }).then(res => {
                setHolidays(res.data.Holidays || []);
                setDataList(dataList => dataList = res.data.SummaryData);
                setShowDataList(showDataList => showDataList = res.data.SummaryData);
                setTableHeader(tableHeader => tableHeader = res['data']['GuiTableCols']);
                // hide spinner
                setShowSpinner(showSpinner => showSpinner = false);
                console.log(res);
                resolve(res);
            }).catch(err => {
                setShowSpinner(showSpinner => showSpinner = false);
                reject(err);
            });
        });
    }

    // function wrapper to refresh summary data 
    const refreshSummaryData = () => {
        getSummaryData(rebateSummaryPeriod).then(res => {
            console.log(res); 
        }).catch(err => {
            console.log(err); 
        }); 
    }

    // event handler for check all box click
    const onCheckboxClick = () =>{
        // check all checkboxes with given status and add to workflowActionCheckedList
        setCheckBoxChange(checkBoxChange => checkBoxChange = !checkBoxChange); // to alert child components of change
        if (checkAll == false){
            setCheckAll(checkAll => checkAll = true);
            // for accept check that workflow is not transmitted before 
            if (payPeriodMode){
                setWorkflowActionCheckedList( workflowActionCheckedList => workflowActionCheckedList = showDataList.filter(canEditPayPeriod));
            }
            else if (workflowStatus === process.env.REACT_APP_ACCEPTED_STATUS){
                setWorkflowActionCheckedList( workflowActionCheckedList => workflowActionCheckedList = dataList.filter((el) => {
                    return el['status'] == workflowStatus && el['transmitted'] === false && userRole === el['userroleid'] && el['eligible'] === true; 
                }));
            }
            // for other statuses add all with status that matches dropdown 
            else {
                setWorkflowActionCheckedList( workflowActionCheckedList => workflowActionCheckedList = dataList.filter((el) => {
                    return el['status'] == workflowStatus && userRole === el['userroleid'] && el['eligible'] === true; 
                }));
            }
        }
        // uncheck all boxes
        else{
            setCheckAll(checkAll => checkAll = false);
            setWorkflowActionCheckedList( workflowActionCheckedList => workflowActionCheckedList = []);
        }
    }

    // enter pay period mode: clears any workflow selection and shows checkboxes on editable rows
    const enterPayPeriodMode = () => {
        setWorkflowActionCheckedList([]);
        setCheckAll(false);
        setCheckBoxChange(checkBoxChange => !checkBoxChange);
        setPayPeriodMode(true);
    }

    // leave pay period mode and clear selection
    const exitPayPeriodMode = () => {
        setPayPeriodMode(false);
        setWorkflowActionCheckedList([]);
        setCheckAll(false);
        setCheckBoxChange(checkBoxChange => !checkBoxChange);
    }

    // open the pay period modal for all currently selected rows
    const onBulkPayPeriodClick = () => {
        setPayPeriodRows(workflowActionCheckedList);
        setPencilModal(true);
    }

    // function to get check box status components
    const getCurrentCheckBoxStatusComponent = () => {
        let selectedItemsLength = workflowActionCheckedList.length;
        if (selectedItemsLength === 0 && payPeriodMode) {
            return <Typography sx={{ whiteSpace: "nowrap", color: "#004364", fontSize: "14px", fontFamily: "Roboto medium" }}>Select Companies to edit Pay Period</Typography>
        }
        if (selectedItemsLength === 0) {
            return <div class="d-flex justify-content-center align-items-center gap-1">
                <Typography sx={{ whiteSpace: "nowrap", color: "#004364", fontSize: "14px", fontFamily: "Roboto medium" }}>Select Companies from below to Review</Typography>
                <ArrowCircleDownIcon sx={{ fontSize: "24px", color: "#004364" }} />
            </div>
        }
        return <Typography sx={{ whiteSpace: "nowrap", color: "#001317", fontSize: "14px", fontFamily: "Roboto medium" }}>
            {workflowActionCheckedList.length > 1
                ? workflowActionCheckedList.length + " Companies selected"
                : 1 + " Company selected"} </Typography>
    }

    // function wrapper to pass row component to datatable
    const RowComponent = (row, count, tableHeader,stickyEnabled,index,selectableRows) =>{
        return(
            <>
                <RebateSummaryRow row={row} count={count} tableHeader={tableHeader} stickyEnabled={stickyEnabled} rowIndex = {index} selectableRows={selectableRows}/>
            </>
        );
    } 

    useEffect(() => {
        setWorkflowActionStatus(workflowActionStatus => workflowActionStatus = workflowStatus); 
        let index = workflowActionStatusList.indexOf(workflowStatus);
        setUserRole(userRole => userRole = userRoleList[index]); 
    }, [workflowStatus, workflowActionStatusList, userRoleList]); 

    // useEffect to run on initial render
    useEffect(() => {
        //grab summary data using tokens
        getSummaryLookups().then(res => {
            console.log(res); 
        }).catch(err => {
            console.log(err); 
        }); 
        workflowActionData.current = workflowActionInfo;
    }, []);

    //usereffect to get data on PeriodId change
    useEffect(() => {
        setPeriodId(periodId => periodId = rebateSummaryPeriod); 
        getSummaryData(rebateSummaryPeriod);
    }, [rebateSummaryPeriod]);

    // useEffect to run list of search/filter functions on table data
    useEffect(() => {
        // do not run on initial render
        if (!initialRender.current){
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: standardFilter, value: rebateFrequency, flag: 1, cols: ['incentivefreq']},             
                {function: standardSearch, value: rebateSummarySearch, flag: 0, cols: ['mastercompanyname', 'mastercompanyid', 'primaryccrm']},
                {function: standardFilter, value: workflowStatus, flag: 1, cols: ['status']}, 
                {function: eligibleFilter, value: eligiblePeriod, flag: 1, cols: ['rebatecycle'], eligibility: workflowEligible}, 
                {function: standardFilter, value: workflowType, flag: 1, cols: ['workflowtypedescription']}, 
                {function: standardFilter, value: rebatePortfolio2, flag: 1, cols: ['incentivetype']}, 
                {function: workflowIndicatorFilter, value: workflowIndicator['id'], flag: 1, cols: ['indicatorid']}, 
                {function: standardFilter, value: companyTypeFilter2, flag: 1, cols: ['companytypedescription']}
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(dataList, functionList);
            // update showDataList
            setShowDataList(showDataList => showDataList = filteredList);
        }
        else{
            initialRender.current = false;
        }
           
    }, [dataList, rebateFrequency, rebateSummarySearch, workflowStatus, eligiblePeriod, workflowEligible, workflowType, rebatePortfolio2, workflowIndicator, companyTypeFilter2]);

    // use effect to handle change in show data list 
    useEffect(() => {
        // if item is not in showDataList remove from workflowActionCheckedList
        let tempList = workflowActionCheckedList.filter((row)=>{
            return (payPeriodMode ? canEditPayPeriod(row) : userRole.includes(row['userroleid'])) && showDataList.includes(row); 
        });
        setWorkflowActionCheckedList(workflowActionCheckedList => workflowActionCheckedList = tempList);
    }, [showDataList, checkAll]);

    // use effect to handle change in workflowAction
    useEffect(() => {
        // set workflowActionStatus
        for (let i = 0; i < workflowActionData.current.length; i++){
            // check workflowActionData to change workflowActionStatus to correct value
            if (workflowAction == workflowActionData.current[i]['tag']){
                setWorkflowStatus(workflowActionData.current[i]['status']);
                break;
            }
        }
        // reset workflowActionCheckedList 
        setWorkflowActionCheckedList(workflowActionCheckedList => workflowActionCheckedList = []);
        // reset checkall box
        setCheckAll(checkAll => checkAll = false);
    }, [workflowAction]);
    
    // useEffect to update elidgeablePeriod filter
    useEffect(() => {
        if (workflowEligible == 'Eligible'){
            setEligiblePeriod(eligiblePeriod => eligiblePeriod = rebateSummaryPeriod); 
        } 
        else if (workflowEligible == 'Non-Eligible'){
            setEligiblePeriod(eligiblePeriod => eligiblePeriod = rebateSummaryPeriod); 
        }
        else {
            setEligiblePeriod(eligiblePeriod => eligiblePeriod = null); 
        }
    }, [rebateSummaryPeriod, workflowEligible]); 


    const settings = {
        dataList, 
        tableHeader, 
        editRowModal, 
        setEditRowModal,
        commentModal, 
        setCommentModal, 
        trailModal, 
        setTrailModal,
        pencilModal, 
        setPencilModal,
        payPeriodRows,
        setPayPeriodRows,
        holidays,
        payPeriodMode,
        canEditPayPeriod,
        exitPayPeriodMode,
        editRow, 
        setEditRow,
        checkAll,
        setCheckAll,
        workflowActionCheckedList, 
        setWorkflowActionCheckedList,
        checkBoxChange,  
        showDataList, 
        setShowDataList,
        workflowAction, 
        setWorkflowAction,
        workflowActionList, 
        setWorkflowActionList,
        workflowActionData, 
        workflowActionStatus, 
        setWorkflowActionStatus,
        multipartWorkflowModal, 
        setMultipartWorkflowModal, 
        workflowButtonCss, 
        workflowOptOut, 
        workflowReviewAction, 
        multipartWorkflowAction, 
        setMultipartWorkflowAction,
        userRole,
        getSummaryData,
        periodId, 
        refreshSummaryData, 
        snackbarAlert, 
        showSnackbar, 
        setShowSnackbar, 
        snackbarMessage, 
        snackbarColor, 
        workflowStatus, 
    };

    return(
        <div class='summary-page'>
            {/* wrap children so they can access PageContext variables */}
            <PageContext.Provider value={ settings }>
                {/* header and navslider present on every page */}
                <HeaderBanner />
                {/* breadcrumbs */}
                <div className="pt-1 ps-3 ms-3">
                    <PageBreadcrumbs />
                </div>
                {/* all modals that can be activated on page. Default for each modal is hidden state */}
                <RebateSummaryEditRowModal/> 
                <RebateCommentModal />
                <RebateTrailModal />
                <RebatePayoutEditModal />
                {/* <MulitpartWorkflowModal checkList={workflowActionCheckedList}/> */}
                <MultipartOffcanvas checkList={workflowActionCheckedList}/>
                {/* snackbar to show alerts on screen */}
                <SnackbarAlert />
                <div className="container-fluid d-flex flex-column" >
                    <div className="d-flex flex-column flex-grow-1 p-2">
                        <div className="p-3 mb-3" style={{ borderRadius: '12px', background: '#fff' }}>
                            <div className='d-flex justify-content-between'>
                                    <div className='d-flex flex-wrap gap-3' >
                                            <PageDropdownRedux alignContent='left' tag='Payout Period' value={rebateSummaryPeriod} list={periodList} setValue={setRebateSummaryPeriod} width={'6rem'} /> 
                                            <PageDropdownRedux alignContent='left' tag='Frequency' list={frequencyList} value={rebateFrequency} setValue={setRebateFrequency} width={'7rem'} />
                                            <PageDropdownRedux alignContent='left' tag='Eligible' list={workflowEligibleList}  value={workflowEligible} setValue={setWorkflowEligible} width={'7rem'} />
                                            <PageDropdownRedux alignContent='left' tag='Workflow' list={workflowTypeList}  value={workflowType} setValue={setWorkflowType} width={'7rem'} />
                                            <PageDropdownRedux alignContent='left' tag='Portfolio' list={rebatePortfolioList}  value={rebatePortfolio2} setValue={setRebatePortfolio2} width={'14rem'} />
                                            <PageDropdownRedux alignContent='left' tag='Company Type' list={companyTypeFilterList}  value={companyTypeFilter2} setValue={setCompanyTypeFilter2} width={'14rem'} />
                                            <PageDropdownReduxWithIdObj alignContent='left' tag='Indicator' list={workflowIndicatorList} obj={workflowIndicator} setObj={setWorkflowIndicator} width={'14rem'}/>
                                    <div className='pe-3'>
                                        <PageInputReduxTooltip tag={ process.env.REACT_APP_MASTER_COMPANY_NAME_TAG + ' | ' + process.env.REACT_APP_MASTER_COMPANY_ID_TAG + ' | Primary ' + process.env.REACT_APP_CCRM_DESCRIPTION} tooltip={ process.env.REACT_APP_MASTER_COMPANY_NAME_TAG + ' | ' + process.env.REACT_APP_MASTER_COMPANY_ID_TAG + ' | Primary ' + process.env.REACT_APP_CCRM_DESCRIPTION} value={rebateSummarySearch} setValue={setRebateSummarySearch} width={'250px'} />
                                    </div>
                                    <div className= "pe-3 align-self-center text-decoration-underline" style={{color: `${enableReset ? '#0295BE': '#BDBDBD'}`, cursor: 'pointer', fontFamily: 'Roboto medium'}} onClick={() => enableReset ? resetToDefault(): null}>
                                        Reset All
                                    </div>
                                </div>    
                                <div className='align-self-start'>
                                    <ExportExcelButton tag='ccap-rebate-summary' dataList={showDataList} tableHeader={tableHeader.slice(0, tableHeader.length - 2)} formatList={fmtList} />
                                </div>
                            </div>
                        </div>
                        <div className="flex-grow-1" style={{ borderRadius: '12px', background: '#fff' }}>
                            <div className='m-3 d-flex justify-content-between'>
                                <PageDropdownRedux isColorCoded={true} tag='Showing Current Workflow Status' list={workflowActionStatusList} value={workflowStatus} setValue={setWorkflowStatus} />
                                {/* dynamic multipart workflow action button that changes based on action chosen in dropdown  */}
                                
                                <div className='d-flex'>
                                    <div className='align-self-center'>
                                        <Typography>{getCurrentCheckBoxStatusComponent()}</Typography>
                                    </div>
                                    {payPeriodMode ?
                                        <div className='align-self-center d-flex gap-2'>
                                            <ButtonComponent tag={'Cancel'} width={'96px'}
                                                border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'}
                                                onButtonClick={exitPayPeriodMode}
                                            />
                                            <ButtonComponent tag={'Edit Pay Period'} width={'140px'}
                                                border={'#fcd800 1px solid'} background={'#fcd800'} color={'#001317'}
                                                disabled={workflowActionCheckedList.length === 0}
                                                disabledColor={'#BDBDBD'} disabledBorder={'#ECECEC 1px solid'} disabledBackground={'#ECECEC'}
                                                onButtonClick={onBulkPayPeriodClick}
                                            />
                                        </div>
                                    :
                                        <>
                                            {showDataList.some(canEditPayPeriod) &&
                                                <div className='align-self-center me-2'>
                                                    <ButtonComponent tag={'Bulk Pay Period'} width={'140px'}
                                                        border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'}
                                                        onButtonClick={enterPayPeriodMode}
                                                    />
                                                </div>
                                            }
                                            <div className='align-self-center'>
                                                {workflowActionCheckedList.length > 0 && <MultipartWorkflowButton  enableReopen ={'true'}/>}
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                            <OrderedDataTable RowComponent={RowComponent} tableHeader={tableHeader} dataList={showDataList} showSpinner={showSpinner} numToPage={50} skeletonHeight='28vh'
                                selectedRowsList={workflowActionCheckedList} sortingEnabled={true} selectAllStatus={checkAll} onSelectAll={(e) => onCheckboxClick(e)} stickyFirstColumnEnabled={true}
                                selectableRows />
                        </div>
                    </div>
                </div>
                <Footer cssClassName="footer-main-comp"/>
            </PageContext.Provider>
        </div>
    );
}

export default RebateSummaryPage;